import {
  alertRejected,
  alertWaiting,
  forgotPasswordFailure,
  forgotPasswordRequest,
  forgotPasswordSuccess,
  loginFailure,
  loginRequest,
  loginSuccess,
  logoutRequest,
  logoutSuccess,
  registerPartnerFailure,
  registerPartnerRequest,
  registerPartnerSuccess,
  resetPasswordFailure,
  resetPasswordRequest,
  resetPasswordSuccess,
} from "./authSlice";
import { call, put, takeLatest } from "redux-saga/effects";
import {
  forgotPasswordApi,
  loginApi,
  registerPartnerApi,
  resetPasswordApi,
} from "./authApi";

function* handleLogin({ payload }) {
  try {
    const res = yield call(loginApi, payload);
    yield put(loginSuccess({ ...res.data, ...payload }));
  } catch (error) {
    if (error?.response?.data?.code === "WAITING_FOR_DECISION") {
      yield put(
        alertWaiting({
          text: error?.response?.data?.code,
          ...payload,
        })
      );
      return;
    }
    if (error?.response?.data?.code === "REJECTED") {
      yield put(
        alertRejected({
          text: error?.response?.data?.code,
          ...payload,
        })
      );
      return;
    }
    yield put(loginFailure(error?.response?.data?.code));
  }
}

function* handleLogout() {
  yield put(logoutSuccess());
}

function* handleRegisterPartner({ payload }) {
  try {
    const res = yield call(registerPartnerApi, payload);
    yield put(registerPartnerSuccess(res.data));
  } catch (error) {
    yield put(registerPartnerFailure(error?.response?.data?.code));
  }
}

function* handleForgotPassword({ payload }) {
  try {
    yield call(forgotPasswordApi, payload);
    yield put(forgotPasswordSuccess());
  } catch (error) {
    yield put(forgotPasswordFailure(error?.response?.data?.code));
  }
}

function* handleResetPassword({ payload }) {
  try {
    yield call(resetPasswordApi, payload);
    yield put(resetPasswordSuccess());
  } catch (error) {
    yield put(resetPasswordFailure(error?.response?.data?.code));
  }
}

export default function* authSaga() {
  yield takeLatest(loginRequest.type, handleLogin);
  yield takeLatest(logoutRequest.type, handleLogout);
  yield takeLatest(registerPartnerRequest.type, handleRegisterPartner);
  yield takeLatest(forgotPasswordRequest.type, handleForgotPassword);
  yield takeLatest(resetPasswordRequest.type, handleResetPassword);
}
